module.exports = __webpack_public_path__ + "img/scissors.be5030ca.webp";